import useSisenseCompetitionCategoryNoDefaultDropdown from "./UseSisenseCompetitionCategoryNoDefaultDropdown";

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import Constants from "@usas/ui-web/utils/Constants";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SisenseCompetitionCategoryNoDefaultDropdown = ({ label, name, value, error, message, onChange }) => {
  const { competitionCategoryNoDefaultOptions, isLoading } = useSisenseCompetitionCategoryNoDefaultDropdown();

  return isLoading === true
    ? <span className={global.LoadingMsg}>{Constants.LOADING_MSG}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={competitionCategoryNoDefaultOptions.options}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={isLoading === true}
      />
    );
};

export default SisenseCompetitionCategoryNoDefaultDropdown;